// @flow

import { useState, useEffect } from "react";

import SubmissionExerciseDataService from "../../axios/services/submission-exercises.service";
import { displayNameOfUser, setRevisionUser } from "../../shared/revisionUserStore";

import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { b64DecodeUnicode } from "@kea-mod/common/components/b64";
import { getStudentSolutionModelId } from "../../shared/studentSolutionLookup";

import { ModelCardComponentMU } from "@kea-mod/common/components/ModelCardComponentMU";
import MDEditor from "@uiw/react-md-editor";
import ExerciseDataService from "@kea-mod/common/axios/services/ExerciseDataService";
export const SubmissionPage = () => {
  let { id } = useParams();
  const { t } = useTranslation();

  const [submission_exercise, setSubmission_exercise] = useState({}) as any;

  const [modelId, setModelId] = useState(-1);
  const [modelLoadFailed, setModelLoadFailed] = useState(false);
  const [description, setDescription] = useState("");
  const [scenario, setScenario] = useState("");

  const [submissionFlag, setSubmissionFlag] = useState(false);
  const [understandingFlag, setUnderstandingFlag] = useState(false);
  const [exerciseId, setExerciseId] = useState(-1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  useEffect(() => {
    SubmissionExerciseDataService.getSubmissionExercise(id)
      .then((response: any) => {
        setSubmission_exercise(response.data.data);
        console.log(response.data.data);
        // Opening this page directly, or reloading it, has to name the right person, so
        // the breadcrumb takes its name from the submission that was actually loaded.
        setRevisionUser(id, displayNameOfUser(response.data.data.user));
        setDescription(b64DecodeUnicode(response.data.data.exercise.description) as string);
        setExerciseId(response.data.data.exerciseId);
        if (response.data.data.type === "creation") {
          setSubmissionFlag(true);
          setScenario(b64DecodeUnicode(response.data.data.exercise.creation.scenario) as string);
        } else {
          setUnderstandingFlag(true);
          //getModelUnderstanding();
        }
      })
      .catch((e: any) => {
        console.log(e);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!understandingFlag) {
      return;
    }
    ExerciseDataService.get(exerciseId, "authorui")
      .then((response: any) => {
        let res = response.data.data;
        const inputModelId = res.understanding.models.inputs[0]?.id;
        if (inputModelId === undefined) {
          setModelLoadFailed(true);
          return;
        }
        setModelId(inputModelId);
      })
      .catch((e: any) => {
        console.log(e);
        setModelLoadFailed(true);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [understandingFlag]);

  useEffect(() => {
    if (!submissionFlag) {
      return;
    }
    setModelLoadFailed(false);
    getStudentSolutionModelId(exerciseId, id)
      .then((foundModelId: any) => {
        if (foundModelId === undefined) {
          setModelLoadFailed(true);
          return;
        }
        setModelId(foundModelId);
      })
      .catch((e: any) => {
        console.log(e);
        setModelLoadFailed(true);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submissionFlag]);

  return (
    <div className="card">
      <header className="card-header">
        <p className="card-header-title">
          {t("FeedbackForExercise")} »{submission_exercise.exercise ? submission_exercise.exercise.name : ""}«
        </p>
      </header>
      <div className="card-content">
        <div className="content" data-color-mode="light">
          <MDEditor.Markdown source={description} />
        </div>
        <div className="content" data-color-mode="light">
          <MDEditor.Markdown source={scenario} />
        </div>
        <div className="content">
          {modelId !== -1 && modelId !== undefined ? (
            <ModelCardComponentMU modelId={modelId.toString()} />
          ) : modelLoadFailed ? (
            <div className="notification is-danger is-light">{t("modelLoadFailed")}</div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
};
